module.exports = "<my-pieces-edit-form my-pieces=\"$$piece.data.myPieces\"\n  my-wagon-id=\"$$wagon.local.getCurrentScrappedId()\">\n</my-pieces-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/sale/templates/editPieces.html
// module id = 1624
// module chunks = 0